// RecyclingsFormFields.js
import React from 'react';
import {
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import {
  TextInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  required,
} from 'react-admin';

const RecyclingsFormFields = () => {
  const theme = useTheme();

  return (
    <>
      {/* Basic Fields */}
      <TextInput source="name" label="Nome" validate={required()} fullWidth />
      <TextInput source="componentName" label="Nome do Componente" validate={required()} fullWidth />
      <TextInput source="material" label="Material" validate={required()} fullWidth />
      <TextInput source="ecoponto" label="Ecoponto" validate={required()} fullWidth />
      <BooleanInput source="compost" label="Compostável"/>

      {/* Preparations (editable array) */}
      <Typography variant="h6" gutterBottom>Preparações</Typography>
      <ArrayInput source="preparations" label={false}>
        <SimpleFormIterator>
          <Box
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              padding: 2,
              marginBottom: 2,
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <TextInput source="" label="Preparação" validate={required()} fullWidth />
          </Box>
        </SimpleFormIterator>
      </ArrayInput>
    </>
  );
};

export default RecyclingsFormFields;
